module.exports = __webpack_public_path__ + "static/media/Icon_AD220B.c483d92a.png";